import { gql } from '@apollo/client';

export const RESEND_USER_INVITE = gql`
  mutation ResendUserInvite ($inviteId: String!) {
    resendUserInvite(invite_id: $inviteId)
  }
`;
